import { Component, ChangeDetectionStrategy, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataGridCellContext, DataGridTemplateMap, DataGridEditorContext, DataGridEditorEvent } from '../data-grid/data-grid.model';
import { SamplesGridCellType, SamplesGridDataCellData, SamplesGridDataChangeEvent, SamplesGridEditorData, SamplesGridEditorType, SamplesGridViewModel } from './samples-grid.model';
import { SamplesGridTextCellTemplateComponent } from './internal/cells/text-cell-template.component';
import { SamplesGridDataCellTemplateComponent } from './internal/cells/data-cell-template.component';
import { SamplesGridStackedCellTemplateComponent } from './internal/cells/stacked-cell-template.component';
import { SamplesGridToggleCellTemplateComponent } from './internal/cells/toggle-cell-template.component';
import { SamplesGridDataEditorTemplateComponent } from './internal/editors/data-editor-template.component';
import { required } from '../../shared/model/invariant';

@Component({
    standalone: false,
    selector: 'mibi-samples-grid-view',
    templateUrl: './samples-grid-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SamplesGridViewComponent implements OnInit {

    @Input() model!: SamplesGridViewModel;
    @Output() dataChange = new EventEmitter<SamplesGridDataChangeEvent>();

    cellTemplates!: DataGridTemplateMap<DataGridCellContext, SamplesGridCellType>;
    editorTemplates!: DataGridTemplateMap<DataGridEditorContext, SamplesGridEditorType>;

    @ViewChild('textCellTemplate', { static: true })
    private textCellTemplate!: SamplesGridTextCellTemplateComponent;

    @ViewChild('dataCellTemplate', { static: true })
    private dataCellTemplate!: SamplesGridDataCellTemplateComponent;

    @ViewChild('stackedCellTemplate', { static: true })
    private stackedCellTemplate!: SamplesGridStackedCellTemplateComponent;

    @ViewChild('toggleCellTemplate', { static: true })
    private toggleCellTemplate!: SamplesGridToggleCellTemplateComponent;

    @ViewChild('dataEditorTemplate', { static: true })
    private dataEditorTemplate!: SamplesGridDataEditorTemplateComponent;

    ngOnInit(): void {
        this.cellTemplates = {
            [SamplesGridCellType.TEXT]: this.textCellTemplate.template,
            [SamplesGridCellType.DATA]: this.dataCellTemplate.template,
            [SamplesGridCellType.STACKED]: this.stackedCellTemplate.template,
            [SamplesGridCellType.TOGGLE]: this.toggleCellTemplate.template
        };
        this.editorTemplates = {
            [SamplesGridEditorType.DATA]: this.dataEditorTemplate.template
        };
    }

    onEditorConfirm(e: DataGridEditorEvent<SamplesGridEditorData>): void {
        if (e.data === undefined) {
            return;
        }

        const oldData = required(
            this.model.cellData[e.rowId]?.[e.colId],
            `cell data ${e.rowId}/${e.colId}`
        ) as SamplesGridDataCellData;

        if(e.data === oldData.value) {
            return;
        }

        this.dataChange.emit(e as SamplesGridDataChangeEvent);
    }
}
